export default __webpack_public_path__ + "static/media/flying-book.747aad07.svg";